angular.module('rental')
    .controller('RentalResourceEditController', function (toastr, $scope, $rootScope, $uibModalInstance, Principal, Property, RentalResource, RentalResourceConst, data, RentalResourceService) {
        this.$onInit = () => {
            this.item = data
        }

        this.canChangeSettings = () => {
            return Principal.hasAnyAuthority([RentalResourceConst.RoleResourceWrite])
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = RentalResource.update(this.item).$promise
            } else {
                promise = RentalResource.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(RentalResourceConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
        $scope.$on(RentalResourceConst.eventDelete, () => $uibModalInstance.dismiss());
    })
